import camelToWords from '../../../helpers/camelToWords';
import { globalUpdatePresetOrProperty } from '../../../store/global/actions';
import Back from '../Back';
import Content from '../Content';
import castValue from '../helpers/castValue';
import useGetValue from '../hooks/useGetValue';
import Checkbox from './Checkbox';
import styles from './EditProperty.module.scss';
import Input from './Input';
import { useMemo, useState } from 'react';
import ReactJson from 'react-json-view';
import { useDispatch } from 'react-redux';

const EditProperty = ({ payload }) => {
  const name = useMemo(() => camelToWords(payload.name), [payload.name]);
  const dispatch = useDispatch();
  const defaultValue = useGetValue(`default.${payload.id}`);
  const [time, setTime] = useState(Date.now());

  const about = useMemo(() => {
    return {
      key: payload.id,
      name: payload.name,
      type: payload.type,
      defaultValue,
    };
  }, [payload, defaultValue]);

  const onSubmit = (data) => {
    dispatch(globalUpdatePresetOrProperty(payload.id, castValue(payload.type, data.field)));

    if (payload.commitAction) {
      dispatch(payload.commitAction);
    }

    setTime(Date.now());
  };

  const revert = () => {
    dispatch(globalUpdatePresetOrProperty(payload.id, defaultValue));

    if (payload.commitAction) {
      dispatch(payload.commitAction);
    }

    setTime(Date.now());
  };

  return (
    <>
      <Back title={name} index={payload.menuIndex} />

      <Content>
        {payload.type !== 'boolean' && <Input key={payload.id} payload={payload} time={time} submit={onSubmit} />}

        {payload.type === 'boolean' && <Checkbox key={payload.id} payload={payload} submit={onSubmit} />}

        <div className={styles.revert}>
          <button onClick={revert}>Revert default</button>
        </div>

        <div className={styles.details}>
          <ReactJson src={about} theme="tomorrow" name="field" />
        </div>
      </Content>
    </>
  );
};

export default EditProperty;
